import { apiClient } from '../client';
import { ApprovalLimit, PermissionScope } from '../../types/admin';

export const approvalLimitsApi = {
  list: (userId: number) => apiClient.get<{ data: ApprovalLimit[] }>(`/api/admin/users/${userId}/approval-limits`),
  create: (userId: number, input: { module: string; maxAmount: number; currencyCode: string; scope: PermissionScope }) =>
    apiClient.post<{ data: { id: number } }>(`/api/admin/users/${userId}/approval-limits`, input),
  update: (limitId: number, input: { module: string; maxAmount: number; currencyCode: string; scope: PermissionScope }) =>
    apiClient.put<{ data: { id: number } }>(`/api/admin/approval-limits/${limitId}`, input),
};
